"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StructureClusterNames = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
function StructureClusterNames({ firstName, secondaryName, isCentered = false, }) {
    return ((0, jsx_runtime_1.jsxs)(Names, { isCentered: isCentered, "data-e2e": 'StructureClusterNames_Names', children: [(0, jsx_runtime_1.jsx)(PrimaryName, { "data-e2e": 'StructureClusterNames_PrimaryName', children: firstName }), (0, jsx_runtime_1.jsxs)(SecondaryName, { "data-e2e": 'StructureClusterNames_SecondaryName', children: ["(", secondaryName, ")"] })] }));
}
exports.StructureClusterNames = StructureClusterNames;
const Names = styled_components_1.default.div `
  width: 100%;
  color: ${({ theme }) => theme.grasshopper.text.white};
  background-color: transparent;
  padding: 0 8px;
  text-align: ${({ isCentered }) => (isCentered ? 'center' : 'left')};

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    padding: 0;
  `)};
`;
const PrimaryName = styled_components_1.default.div `
  font-size: 24px;
  font-weight: 700;
  line-height: 33.6px;
  margin: 0;
`;
const SecondaryName = styled_components_1.default.div `
  font-size: 16px;
  font-weight: 400;
  line-height: 18.32px;
  margin: 8px 0 0;
`;
